/**
 * Shown when a page opened by the booking id in its URL cannot load it (40973): the booking does not exist, is not
 * the caller's, or the id is not a booking id. One message for all three, as the API gives one answer for them.
 */
export const BOOKING_NOT_FOUND_MESSAGE = 'This booking could not be found, or is not assigned to you.';
